// Tabs/TabPanelContent.regulations.tsx
import React from 'react';
import DynamicTabContentTable from './DynamicTabContentTable';
import DynamicTabContentCard from "./DynamicTabContentCard";

interface TabPanelContentProps {
    dynamicCollections: any[];
}

const TabPanelContentRegulations: React.FC<TabPanelContentProps> = ({ dynamicCollections }) => (
    <div className="row">
        <div className="col-9 col-sm-9">
            <DynamicTabContentTable dynamicCollections={dynamicCollections} tabName="regulations" />
        </div>
        <div className="col-3 col-sm-3">
            <DynamicTabContentCard dynamicCollections={dynamicCollections} tabName="regulations" />
        </div>
    </div>
);

export default TabPanelContentRegulations;
